// extracted by mini-css-extract-plugin
export default {"RecommendedContentContainer":"RecommendedSection_RecommendedContentContainer__Cre9W"};